import React ,{ useEffect, useState } from "react";
import './css/home.css';
import videoSource from '../assets/videos/bgvideo.mp4'
import videoSourceMobile from '../assets/videos/bgmvideo.mp4';
import MoveImage from "./MoveImage";
import img1 from '../assets/gallery/A1.jpg';
import img2 from '../assets/images/resturent.png'
import Room1 from '../assets/images/Room1.jpeg';
import Room3 from '../assets/images/Room3.jpeg';
import { Card, Button } from 'react-bootstrap';
import Slider from "./slider";
// import AnimatedFlexCards from "./AnimatedFlexCards";


const Home = () => {


    const [isVisible, setIsVisible] = useState(false); // Initialize visibility state for offers
    const [cardVisible, setCardVisible] = useState(false); 

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsVisible(true);
            }
            if (window.scrollY > 1450) {
                setCardVisible(true);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div>
        <div className="container">
            <video className="background-video" src={videoSource} autoPlay loop muted playsInline>
                Your browser does not support the video tag.
            </video>
            <video className="background-video-mobile" src={videoSourceMobile} autoPlay loop muted playsInline>
                Your browser does not support the video tag.
            </video>
            <div className="videoOverlayer dotted"></div>
            <div className="welcomeContainer">
                <div className="welcomeFont"> 
                    <p className="Welcometo">Welcome to</p>
                    <p className="WelcomehotelName">Bolagala Nature Resort</p></div>
                </div>
        </div>
        <div className="container1">
          <div className="container1a">
            <img src={img1} alt="Bolagala Nature Resort Info" />
            <div className="greview" style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(80px)',
                transition: 'opacity 0.5s ease-in-out, transform 2s ease-in-out',
                visibility: isVisible ? 'visible' : 'hidden'
            }}>
                <p className="greeting1">Welcome to Bolagala Nature Resort</p>
                <p className="greeting2">Embrace Nature’s Tranquil Charm</p>
                <p className="reviewP">Nestled in the peaceful surroundings of Madampella Pahala, Bolagala Nature Resort offers the perfect retreat. With river views, comfortable accommodations, and an inviting outdoor pool, it's a place to unwind and reconnect with nature. Whether you're here for relaxation or adventure, every moment at our resort is designed to leave you refreshed and inspired.</p>  
                <div className="greviewbox">
                    <script src="https://static.elfsight.com/platform/platform.js" async></script>
                    <div class="elfsight-app-50d3ace2-b7ee-406c-ab54-0e2c20647d9a" data-elfsight-app-lazy></div>
                </div>  
                </div>
            {/* <div className="overlaylogo">
                <img src={overlaylogo} alt="Overlay" className="overlay-image" />
            </div> */}
            </div>
        </div>

        <div className="container3">
                <h1>Escape to Tranquility at Bolagala</h1>
                <p>Nestled amidst serene landscapes, Bolagala Nature Resort is a perfect escape from the fast-paced city life. Whether you're looking to explore nature trails, unwind in peaceful surroundings, or indulge in mouthwatering meals, our resort offers a relaxing retreat for all.</p>
                <div className="features"> 
                    <div className="feature 1">
                        <img src="https://img.icons8.com/ios/452/forest.png" alt="Nature" />
                        <h3>Explore Nature</h3>
                    </div>
                    <div className="feature 2">
                    <img src="https://img.icons8.com/ios/452/relax--v1.png" alt="Relax Icon" />
                        <h3>Relax & Unwind</h3>
                    </div>
                    <div className="feature 3">
                        <img src="https://img.icons8.com/ios/452/restaurant.png" alt="Dining" />
                        <h3>Dine in Style</h3>
                    </div>
                    <div className="feature 4">
                        <img src="https://img.icons8.com/ios/452/swimming-pool.png" alt="Pool" />
                        <h3>Swim & Relax</h3>
                    </div>
                    <div className="feature 5">
                        <img src="https://img.icons8.com/ios/452/bar.png" alt="Mini Bar" />
                        <h3>Mini Bar</h3>
                    </div>

                </div>
                <button class="button-89" >Explore More</button>
            </div>

        <div class="container2">
                <div className="card-container">
                    <Card className="custom-card">
                        <Card.Img variant="top" src={Room1} className="custom-card-img" />
                        <Card.Body>
                            <div style={{
                                margin:'25px',
                                opacity: cardVisible ? 1 : 0,
                                transform: cardVisible ? 'translateY(0)' : 'translateY(50px)',
                                transition: 'opacity 0.5s ease-in-out, transform 2s ease-in-out',
                                visibility: cardVisible ? 'visible' : 'hidden'
                            }}>
                                <Card.Title>Luxury Experience</Card.Title>
                                <h3>Deluxe Rooms</h3>
                                <Card.Text>
                                Discription
                                    <ul>
                                        <li>King-size Bed</li>
                                        <li>Free Wi-Fi</li>
                                        <li>Exclusive Access</li>
                                        <li>VIP Treatment</li>
                                    </ul>
                                </Card.Text>
                            </div>
                            <Button variant="outline-light">BOOK NOW</Button>
                        </Card.Body>
                    </Card>

                    <Card className="custom-card">
                        <Card.Body  >
                            <div style={{
                                margin:'25px',
                                opacity: cardVisible ? 1 : 0,
                                transform: cardVisible ? 'translateY(0)' : 'translateY(50px)',
                                transition: 'opacity 0.5s ease-in-out, transform 2s ease-in-out',
                                visibility: cardVisible ? 'visible' : 'hidden',
                                height: '500px',
                                
                            }}>
                                <div className="crdborder">
                                <h3>Rooms</h3>
                                <Card.Text>
                                <h4>Do you prefer accommodation directly in a hotel, with all the services and comforts that belong to it ? We offer comfortably furnished rooms and modern suits.</h4>
                                </Card.Text>
                                <div className="cardbutton">
                                <button class="button-89" >Choose</button>
                                </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>

                    <Card className="custom-card">
                        <Card.Img variant="top" src={Room3} className="custom-card-img" />
                        <Card.Body>
                            <div style={{
                                margin:'25px',
                                opacity: cardVisible ? 1 : 0,
                                transform: cardVisible ? 'translateY(0)' : 'translateY(50px)',
                                transition: 'opacity 0.5s ease-in-out, transform 2s ease-in-out',
                                visibility: cardVisible ? 'visible' : 'hidden'
                            }}>
                                <Card.Title>Lifestyle Management</Card.Title>
                                <h3>Family Rooms</h3>
                                <Card.Text>
                                    Discription
                                    <ul>
                                        <li>Double Bed</li>
                                        <li>Fan</li>
                                        <li>En-suite Bathroom with Hot Water</li>
                                     
                                    </ul>
                                </Card.Text>
                            </div>
                            <Button variant="outline-light">BOOK NOW</Button>
                        </Card.Body>
                    </Card>
                </div>
            </div>

            <div className="container4">
            <Slider/>
            </div>
                            {/* <div className="container5">
            <AnimatedFlexCards />
            </div> */}

            <div className="container1 res">
          <div className="container1a ">
            
            <div className="greview rest" style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(80px)',
                transition: 'opacity 0.5s ease-in-out, transform 2s ease-in-out',
                visibility: isVisible ? 'visible' : 'hidden',
                
            }}>
                <p className="greeting2" style={{color:'#a59771' , fontSize:'30px'}}>The Restaurant & Mini Bar</p>
                <p className="reviewP">At Bolagala Nature Resort, our Restaurant and Mini Bar offer more than just meals and drinks—they create an experience. Indulge in an array of flavorful dishes, from traditional Sri Lankan cuisine to international favorites, all prepared with fresh, local ingredients. Relax with a refreshing beverage, whether it’s a tropical juice, mocktail, or expertly crafted cocktail. Surrounded by nature’s beauty, these dining spots provide a perfect setting to unwind and enjoy. Savor every moment, making memories that will stay with you long after your stay.</p>  
                
                </div>
                <img src={img2} alt="Bolagala Nature Resort Info" />
            {/* <div className="overlaylogo">
                <img src={overlaylogo} alt="Overlay" className="overlay-image" />
            </div> */}
            </div>
        </div>

        <div className="container6">
         <MoveImage /> 
        </div>
        </div>
    );
};

export default Home;
